import { render, staticRenderFns } from "./flavorsList.vue?vue&type=template&id=92a7e146"
import script from "./flavorsList.vue?vue&type=script&lang=js"
export * from "./flavorsList.vue?vue&type=script&lang=js"
import style0 from "./flavorsList.vue?vue&type=style&index=0&id=92a7e146&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports